import React, { memo, useState } from 'react';
import Proptypes from 'prop-types';
import CircleLoader from 'common/components/elements/loader/circle';
import Button from 'common/components/elements/buttons/primary';

const ImageCard = ({
   src,
   customStyle = {},
   isLockedForSFW,
   onClickVerifyButton,
   isHoveredOnTheImage,
}) => {
   const [imgLoad, setImgLoad] = useState(true);

   return (
      <div
         className='w-full h-full relative'
         style={ customStyle }
      >
         <img
            src={ src }
            className='w-full object-cover h-full'
            alt='pretty'
            onLoad={ () => setImgLoad(false) }
            style={ {
               filter: isLockedForSFW ? 'blur(32px)' : '',
            } }
         />
         {
            imgLoad && (
               <div className='w-full h-full absolute inset-0 flex items-center justify-center'>
                  <CircleLoader color='major-dark' />
               </div>
            )
         }
         {
            isHoveredOnTheImage && isLockedForSFW &&
               <div
                  className='absolute top-0 flex flex-col items-center justify-center gap-4 w-full h-full z-10 bg-major-60'
                  style={ {
                     backdropFilter: 'blur(32px)',
                  } }
                  role='presentation'
                  onClick={ () => {
                     if(onClickVerifyButton) onClickVerifyButton()
                  } }
               >
                  <p className='text-lg font-semibold text-major-dark text-center'>Verify age to unblur content</p>
                  <Button
                     text={  'Verify my age' }
                     borderRadius='large'
                     backgroundColor={ 'transparent' }
                     textColor='major-dark'
                     textSize='small'
                     onClick={ (e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        if(onClickVerifyButton) onClickVerifyButton()
                     } }
                     classNames='!w-fit border border-major-dark py-2.5 px-3.5'
                     textMarginX='0'
                  />
               </div>
         }
      </div>
   );
};

ImageCard.propTypes = {
   src: Proptypes.any,
   customStyle: Proptypes.object,
   isLockedForSFW: Proptypes.bool,
   onClickVerifyButton: Proptypes.func,
   isHoveredOnTheImage: Proptypes.bool,
};

export default memo(ImageCard);
